import type { ComposerSubmitComment } from '@liveblocks/react-ui/primitives'

import { CommentComposer } from '@/components/lemmala-design-system/comment-composer/comment-composer'
import { EDITOR_COMPONENTS } from '@/components/shared/comment/consts'
import { CommentAudienceProvider } from '@/components/shared/comment/context'
import { CommentAudience } from '@/components/shared/comment/types'

type ControlCommentComposerProps = {
  audience: CommentAudience
  placeholder?: string
  onSubmit?: (comment: ComposerSubmitComment) => void | Promise<void>
}

export const ControlCommentComposer = ({
  audience,
  placeholder,
  onSubmit,
}: ControlCommentComposerProps) => (
  <CommentAudienceProvider value={audience}>
    <CommentComposer
      editorComponents={EDITOR_COMPONENTS}
      placeholder={placeholder}
      onSubmit={(comment) => onSubmit?.(comment)}
    />
  </CommentAudienceProvider>
)
